import Clarity from '@microsoft/clarity'

const baseUrl = process.env.NEXT_PUBLIC_APP_BASE_URL || ''
const isDev = baseUrl === 'https://dev.intalent.ai' || baseUrl === 'http://localhost:3000'
const isDemo = baseUrl === 'https://demo.intalent.ai'

/** Demo project ID for dev/demo; use NEXT_PUBLIC_CLARITY_PROJECT_ID for prod when ready */
const CLARITY_PROJECT_ID = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID || 'vmsh3epxw3'

/**
 * Initialize Microsoft Clarity analytics.
 * Call from a client component's useEffect to ensure browser-only execution.
 */
export function initClarity(): void {
    if (typeof window === 'undefined') return
    Clarity.init(CLARITY_PROJECT_ID)
}

/**
 * Identify the current user/session/page to Clarity for better analytics.
 * Call on each page when user or pathname changes.
 * @param customId - Required. Unique user ID (e.g. Auth0 sub)
 * @param customSessionId - Optional. Session identifier
 * @param customPageId - Optional. Page identifier (e.g. pathname)
 * @param friendlyName - Optional. Human-readable name (e.g. email)
 */
export function identifyUser(customId: string, customSessionId?: string, customPageId?: string, friendlyName?: string): void {
    if (typeof window === 'undefined') return
    Clarity.identify(customId, customSessionId ?? '', customPageId ?? '', friendlyName ?? '')
}

type ProductEventPayload = Record<string, string | number | boolean | undefined>

/**
 * Records a custom Smart event in Microsoft Clarity (`Clarity.event` — see package README).
 * Clarity only stores the event name; `detail` is for local debugging (dev console), not sent to Clarity.
 * For session-scoped dimensions in Clarity, use `Clarity.setTag` separately (values must be strings).
 */
export function trackProductEvent(eventName: string, detail?: ProductEventPayload): void {
    if (typeof window === 'undefined') return
    try {
        Clarity.event(eventName)
    } catch {
        // e.g. called before Clarity.init in an edge case
    }
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console -- intentional dev-only product log
        console.debug('[product]', eventName, detail ?? {})
    }
}
